import { apiService } from '@/shared/services/apiServices';
import { TASK_FORM_ERROR_MESSAGES } from '../errors/errorMessages';
import type { SubmittedFormDetails } from '../types';
import taskFormEndpoints from './taskFormEndpoints';

export interface GetSubmittedFormDetailsResult {
  success: boolean;
  data?: SubmittedFormDetails;
  error?: string;
  notFound?: boolean;
  forbidden?: boolean;
}

export async function getSubmittedFormDetails(
  id: string
): Promise<GetSubmittedFormDetailsResult> {
  try {
    const result = await apiService.getAPI(
      taskFormEndpoints.SUBMITTED_FORM_DETAILS(id),
      { skipGlobalErrorRedirect: true }
    );

    if (!result.error && result.data) {
      const body = result.data as {
        message: string;
        data: SubmittedFormDetails;
      };
      return { success: true, data: body.data };
    }

    if (result.status === 404) {
      return { success: false, notFound: true };
    }

    if (result.status === 403) {
      return { success: false, forbidden: true };
    }

    if (result.isNetworkError) {
      return { success: false, error: TASK_FORM_ERROR_MESSAGES.NETWORK_ERROR };
    }

    return { success: false, error: TASK_FORM_ERROR_MESSAGES.DEFAULT_ERROR };
  } catch {
    return { success: false, error: TASK_FORM_ERROR_MESSAGES.UNEXPECTED_ERROR };
  }
}
